/*#__PURE__*/ export default JSON.parse('{"key":"azMenu","type":"root","items":[{"key":"numberOfTopSports","def":3,"type":"number"}]}');